import { useState } from 'react';
import {
  getAudioBufferFromFile,
  trimAudioBuffer,
} from 'services/helpers/audio';
import {
  createAudioFileFromAudioBuffer,
  isAudioFile,
  replaceFileExtension,
} from '../helpers';
import { MAX_AUDIO_DURATION } from '../components/UploadUserLoop/constants';

const useMediaProcessor = () => {
  const [data, setData] = useState<File | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const processMedia = async (file: File) => {
    setIsLoading(true);

    try {
      const audioBuffer = await getAudioBufferFromFile(file);

      const isAudio = isAudioFile(file);
      const isLongerThanLimit = audioBuffer.duration > MAX_AUDIO_DURATION;

      if (isAudio && !isLongerThanLimit) {
        setData(file);
        return file;
      }

      const fileName = replaceFileExtension(file.name, 'mp3');

      if (isLongerThanLimit) {
        const trimmedAudioBuffer = trimAudioBuffer(
          audioBuffer,
          0,
          MAX_AUDIO_DURATION
        );
        const audioFile = await createAudioFileFromAudioBuffer(
          trimmedAudioBuffer,
          `Clip_${fileName}`
        );

        setData(audioFile);
        return audioFile;
      }

      const audioFile = await createAudioFileFromAudioBuffer(
        audioBuffer,
        fileName
      );

      setData(audioFile);
      return audioFile;
    } catch (err) {
      setError(err as Error);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const reset = () => {
    setData(null);
    setIsLoading(false);
    setError(null);
  };

  return [
    processMedia,
    {
      data,
      isLoading,
      error,
      reset,
    },
  ] as const;
};

export default useMediaProcessor;
